exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.model-card[data-v-43b76ad6]:hover {\n  text-decoration: none;\n}\n.card-text[data-v-43b76ad6] {\n  color: #676868;\n}\n.cursor-pointer[data-v-43b76ad6] {\n  cursor: pointer;\n}\n.card[data-v-43b76ad6] {\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n.card[data-v-43b76ad6]:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports
